import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/userprofile/successImg.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { axiosInstance_user } from "../../axiosInstance-user";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  border: "1px solid white",
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
const educationSchema = Yup.object().shape({
  education: Yup.string().required("Education is required"),
  college: Yup.string().required("College is required"),
  // employed_in: Yup.string().required("Employed In is required"),
  occupation: Yup.string().required("Occupation is required"),
  organization: Yup.string().required("Organization is required"),
  experience: Yup.number()
    .required("Experience is required")
    .typeError("Experience must be a number"),
  annual_income: Yup.number()
    .required("Annual Income is required")
    .typeError("Annual Income must be a number")
    .min(0, "Annual Income must be a positive number")
    .max(32767, "Annual Income less than 32,767"),

  // social_media: Yup.string().required("Social Media is required"),
});

export function EducationDetails() {
  const [occupation, setOccupation] = useState([]);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const formik = useFormik({
    initialValues: {
      education: "",
      college: "",
      // employed_in: "",
      occupation: "",
      organization: "",
      experience: "",
      annual_income: "",
      social_media: [],
    },
    validationSchema: educationSchema,
    onSubmit: async (values) => {
      try {
        const dataToSave = {
          profile: {
            education: Number(values.education),
            college: values.college,
            occupation: Number(values.occupation),
            organization: values.organization,
            experience: values.experience,
            annual_income: Number(values.annual_income),
            //social media is array
            social_media: values.social_media
              .split(",")
              .map((item) => item.trim())
              .filter((item) => item !== ""), // remove empty strings
          },
        };

        localStorage.setItem("educationDetails", JSON.stringify(dataToSave));
        handleOpen();
        setTimeout(() => {
          handleClose();
        }, 2000);
      } catch (error) {
        console.error("Error saving to localStorage:", error);
      }
    },
  });
  // get and set form data from localStorage to fields
  // useEffect(() => {
  //   const educationDetails = localStorage.getItem("educationDetails");
  //   if (educationDetails) {
  //     try {
  //       const parsedData = JSON.parse(educationDetails);
  //       formik.setValues(parsedData);
  //     } catch (err) {
  //       console.error("Error parsing saved data:", err);
  //     }
  //   }
  // }, []);
  useEffect(() => {
    const educationDetails = localStorage.getItem("educationDetails");
    if (educationDetails) {
      const parsedData = JSON.parse(educationDetails);

      if (parsedData.profile) {
        formik.setValues({
          education: parsedData.profile.education || "",
          college: parsedData.profile.college || "",
          occupation: parsedData.profile.occupation || "",
          organization: parsedData.profile.organization || "",
          experience: parsedData.profile.experience || "",
          annual_income:
            parsedData.profile.annual_income !== undefined &&
            parsedData.profile.annual_income !== null
              ? parsedData.profile.annual_income
              : "",

          social_media: Array.isArray(parsedData.profile.social_media)
            ? parsedData.profile.social_media.join(", ")
            : parsedData.profile.social_media || "",
        });
      }
    }
  }, []);

  async function LoadOccupation() {
    try {
      const response = await axiosInstance_user.get("/dropdown/occupation");

      if (response.status === 200 && response.data) {
        console.log("occupation", response.data);
        setOccupation(response.data);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }
  useEffect(() => {
    LoadOccupation();
  }, []);
  return (
    <form onSubmit={formik.handleSubmit}>
      <div>
        {/* Row 1 */}
        <div className="education-subcontainer">
          <div>
            <div className="education-label">
              Education <span className="text-danger">*</span>
            </div>
            <div className="education-input">
              <select
                name="education"
                id="education"
                value={formik.values.education}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.education && formik.errors.education
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled selected>
                  Select Education
                </option>
                <option value="1">Pre-Primary Education</option>
                <option value="2">Primary Education</option>
                <option value="3">Secondary Education</option>
                <option value="4">Graduate Degrees</option>
                <option value="5">Master's Degree</option>
                <option value="6">Doctorate (PhD)</option>
                <option value="7">Professional Doctorates</option>
                <option value="8">Vocational Courses</option>
                <option value="9">Non-Graduate</option>
              </select>
              {formik.touched.education && formik.errors.education && (
                <div className="text-danger">{formik.errors.education}</div>
              )}
            </div>
          </div>
          <div>
            <div className="education-label">
              College <span className="text-danger">*</span>
            </div>
            <div className="education-input">
              <input
                type="text"
                name="college"
                placeholder="Enter College Name"
                value={formik.values.college}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.college && formik.errors.college && (
                <div className="text-danger">{formik.errors.college}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="education-subcontainer">
          {/* <div>
            <div className="education-label">Employed In <span className="text-danger">*</span></div>
            <div className="education-input">
              <input
                type="text"
                name="employed_in"
                placeholder="Enter Employed In"
                value={formik.values.employed_in}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.employed_in && formik.errors.employed_in && (
                <div className="text-danger">{formik.errors.employed_in}</div>
              )}
            </div>
          </div> */}

          <div>
            <div className="education-label">
              Occupation <span className="text-danger">*</span>
            </div>
            <div className="education-input">
              <select
                name="occupation"
                id="occupation"
                value={formik.values.occupation}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  formik.setFieldValue("occupation", selectedId);
                  // find selected occupation
                  const selectedOccupation = occupation.find(
                    (item) => item.id == selectedId
                  );

                  if (
                    selectedOccupation &&
                    selectedOccupation.name === "Not working"
                  ) {
                    // auto-fill fields when not working
                    formik.setFieldValue("annual_income", "0");
                    formik.setFieldValue("organization", "N/A");
                  } else {
                    // reset for other occupations
                    formik.setFieldValue("annual_income", "");
                    formik.setFieldValue("organization", "");
                  }
                }}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.religion && formik.errors.religion
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled>
                  Select Occupation
                </option>
                {occupation.map((list) => (
                  <option value={list.id} key={list.id}>
                    {list.name}
                  </option>
                ))}
              </select>
              {formik.touched.occupation && formik.errors.occupation && (
                <div className="text-danger">{formik.errors.occupation}</div>
              )}
            </div>
          </div>

          <div>
            <div className="education-label">
              Annual Income <span className="text-danger">*</span>
            </div>
            <div className="education-input">
              <input
                type="number"
                min="0"
                name="annual_income"
                placeholder="Enter Annual Income"
                value={
                  formik.values.annual_income !== undefined &&
                  formik.values.annual_income !== null
                    ? formik.values.annual_income
                    : ""
                }
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={
                  formik.values.annual_income === 0 ||
                  formik.values.annual_income === "0"
                }
              />
              {formik.touched.annual_income && formik.errors.annual_income && (
                <div className="text-danger">{formik.errors.annual_income}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 3 */}
        <div className="education-subcontainer">
          <div>
            <div className="education-label">
              Organization <span className="text-danger">*</span>
            </div>
            <div className="education-input">
              <input
                type="text"
                name="organization"
                placeholder="Enter Organization"
                value={formik.values.organization}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={formik.values.organization === "N/A"}
              />
              {formik.touched.organization && formik.errors.organization && (
                <div className="text-danger">{formik.errors.organization}</div>
              )}
            </div>
          </div>
          <div>
            <div className="education-label">
              Experience <span className="text-danger">*</span>
            </div>
            <div className="education-input">
              <input
                type="number"
                name="experience"
                min="0"
                placeholder="Enter Experience"
                value={formik.values.experience}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.experience && formik.errors.experience && (
                <div className="text-danger">{formik.errors.experience}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 4 */}
        <div className="education-subcontainer">
          <div>
            <div className="education-label">Social Media <span className="text-danger">*</span></div>
            <div className="education-input">
              <input
                type="text"
                name="social_media"
                placeholder="Social media"
                value={formik.values.social_media}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.social_media && formik.errors.social_media && (
                <div className="text-danger">{formik.errors.social_media}</div>
              )}
            </div>
          </div>
        </div>

        {/* Modal & Button */}
        <div className="btnBasicSave">
          <Button type="submit">Save Changes</Button>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img src={successImg} alt="Success" />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                 Education information saved successfully
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </form>
  );
}
